import { Building2, Fish, Package } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { mockAccommodations, mockActivities, mockPackages } from '../../data/mockData';
import type { CartItem } from '../../services/cartService';

export type MyCartItemDisplayDetails = {
  name: string;
  description: string;
  price: number;
  icon: LucideIcon;
  location?: string;
  capacity?: number;
  duration?: string | number;
};

export function getMyCartItemDetails(item: CartItem): MyCartItemDisplayDetails {
  const fallback = (icon: LucideIcon): MyCartItemDisplayDetails => ({
    name: item.itemName || 'Item',
    description: '',
    price: item.itemPrice,
    icon,
    location: '',
    capacity: 0,
    duration: '',
  });

  if (item.type === 'accommodation') {
    const accommodation = mockAccommodations.find((acc) => acc.id === item.itemId);
    return accommodation
      ? {
          name: item.itemName,
          description: accommodation.description,
          price: item.itemPrice,
          icon: Building2,
          location: accommodation.location,
          capacity: accommodation.capacity,
        }
      : fallback(Building2);
  }
  if (item.type === 'activity') {
    const activity = mockActivities.find((act) => act.id === item.itemId);
    return activity
      ? {
          name: item.itemName,
          description: activity.description,
          price: item.itemPrice,
          icon: Fish,
          duration: activity.duration,
          capacity: activity.capacity,
        }
      : fallback(Fish);
  }
  const pkg = mockPackages.find((p) => p.id === item.itemId);
  return pkg
    ? {
        name: item.itemName,
        description: pkg.description,
        price: item.itemPrice,
        icon: Package,
        duration: pkg.duration,
        capacity: undefined,
        location: undefined,
      }
    : fallback(Package);
}
